import { lazy } from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

//layouts
import BasicLayout from "./layout/BasicLayout";
import MainLayout from './layout/MainLayout';
import PaymentLayout from "./layout/PaymentLayout";
import TicketLayout from "./layout/TicketLayout";
import { withLoading } from "./HOC/withLoading";


//components
const Home = lazy(() => import('./page/HomePage'))
const Login = lazy(() => import('./page/Login'))
const Admin = lazy(() => import('./page/Admin'))
const Ticket = lazy(() => import('./page/TicketList'))
const Cart = lazy(() => import('./page/CartPage'))
const Payment = lazy(() => import('./page/PaymentPage'))
const PaymentSlip = lazy(() => import('./page/PaymentSlip'))
const Look = lazy(() => import('./page/LookUp'))
const TicketIssuance = lazy(() => import('./page/TicketIssuance'))
const QrCode = lazy(() => import('./page/PaymentQrCode'))

const HomePage = withLoading(Home)
const LoginPage = withLoading(Login)
const AdminPage = withLoading(Admin)
const TicketPage = withLoading(Ticket)
const CartPage = withLoading(Cart)
const PaymentPage = withLoading(Payment)
const PaymentSlipPage = withLoading(PaymentSlip)
const LookPage = withLoading(Look)
const TicketIssuancePage = withLoading(TicketIssuance)
const QrCodePage = withLoading(QrCode)


export const Router = () => <BrowserRouter>
    <Routes>
        <Route
            path="/"
            element={<MainLayout />}
        >
            <Route index element={<HomePage />} />
        </Route>
        <Route
            path="/login"
            element={<BasicLayout />}
        >
            <Route path="" element={<LoginPage />} />
        </Route>
        <Route
            path="/admin"
            element={<BasicLayout />}
        >
            <Route path="" element={<AdminPage />} />
        </Route>
        <Route
            path="/select_step"
            element={<TicketLayout />}
        >
            {/* <Route index element={<SelectDate />} /> */}
            <Route path="ticket" element={<TicketPage />} />
            <Route path="cart" element={<CartPage />} />
        </Route>
        <Route
            path="/payment"
            element={<PaymentLayout />}
        >
            <Route index element={<PaymentPage />} />
            <Route path="slip" element={<PaymentSlipPage />} />
            <Route path="qr" element={<QrCodePage />} />

        </Route>
        <Route
            path="/ticket"
            element={<BasicLayout />}
        >
            <Route path="look_up" element={<LookPage />} />
            <Route path="issuance" element={<TicketIssuancePage />} />

        </Route>
    </Routes>
</BrowserRouter>